document.addEventListener('DOMContentLoaded', function () {
  const page = document.querySelector('[data-ld]');
  if (!page) return;
  const dialog = page.querySelector('[data-ld-dialog]');
  const image = page.querySelector('[data-ld-dialog-image]');
  const close = page.querySelector('[data-ld-close]');
  let activeTrigger;
  let previousOverflow = '';
  page.querySelectorAll('[data-ld-zoom]').forEach(function (trigger) {
    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      activeTrigger = trigger;
      image.src = trigger.dataset.src;
      image.alt = trigger.dataset.alt;
      previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      dialog.showModal();
      close.focus();
    });
  });
  close.addEventListener('click', function () { dialog.close(); });
  dialog.addEventListener('click', function (event) {
    if (event.target === dialog) dialog.close();
  });
  dialog.addEventListener('close', function () {
    document.documentElement.style.overflow = previousOverflow;
    if (activeTrigger) activeTrigger.focus();
  });
  const hero = page.querySelector('[data-ld-hero]');
  const buy = page.querySelector('[data-ld-buy]');
  const sticky = page.querySelector('[data-ld-sticky]');
  let pending = false;
  function updateSticky() {
    sticky.classList.toggle('is-visible', hero.getBoundingClientRect().bottom < 0 && buy.getBoundingClientRect().top > window.innerHeight);
    pending = false;
  }
  function scheduleSticky() {
    if (!pending) { pending = true; requestAnimationFrame(updateSticky); }
  }
  window.addEventListener('scroll', scheduleSticky, { passive: true });
  window.addEventListener('resize', scheduleSticky);
  page.addEventListener('toggle', scheduleSticky, true);
  window.addEventListener('load', scheduleSticky);
  updateSticky();
});
